/**
 * Canonical origin for the Scubamail product app (login, workspace, billing, unsubscribe, OAuth).
 * Marketing site is scubamail.io only — do not use it for app links.
 * Set REACT_APP_APP_DOMAIN to override (must be the app host, e.g. app.scubamail.io).
 * Local dev uses the current browser origin so links stay on localhost.
 */
export function getMainAppOrigin(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return window.location.origin.replace(/\/$/, '');
    }
  }

  const raw = process.env.REACT_APP_APP_DOMAIN?.trim();
  if (raw) {
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      return raw.replace(/\/$/, '');
    }
    return `https://${raw.replace(/\/$/, '')}`;
  }

  return 'https://app.scubamail.io';
}

export function mainAppUrl(path: string): string {
  const base = getMainAppOrigin();
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
